import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Http from '../../core/Http';
import Preloader from '../../core/Preloader'; 
import toast from '../../core/toast'; 
import Qrcode from '../../core/qrcode';
import axiosCancel from 'axios-cancel';
 
const $ =window.$;
var qs = require('qs');
class Login extends Component {
    constructor(props){
        super(props); 
        this.state={
            username:'',
            password:'',
            preloader:false,
            qr_code:false,
        };
        this.validator = new SimpleReactValidator();
        $('body').addClass('login-body');
    }
    componentDidMount(){
        let token=localStorage.getItem('token');
        if(token){
            this.props.history.push('/landing');
        }
    }
    submitForm=(checkUser)=>{
      
        if( this.validator.allValid() || checkUser){
            this.setState({preloader:true});
            axiosCancel(Http, { debug: false});
            const requestId = 'loginstuff';
            Http.post('/login', qs.stringify({
                email: checkUser==='guest'?'guest@cattheni.com': this.state.username,
                password:  checkUser==='guest'?'guest@12345':this.state.password,
                qrcode:checkUser && checkUser!=='guest'?checkUser:''
            }),
            {requestId:requestId}
            ).then((resp)=>{
                if(resp && resp.data.status===200 && resp.data.token){
                    localStorage.setItem('token',resp.data.token);
                    localStorage.setItem('m_status',resp.data.m_status);
                    localStorage.setItem('permission',JSON.stringify(resp.data.permission.permission));
                    localStorage.setItem('branch_name',JSON.stringify(resp.data.branch_name)); 
                    localStorage.setItem('institution_name',resp.data.institution_name);
                    localStorage.setItem('username',resp.data.loggedUserName); 
                    window.location.href=window.Basename+'/landing';
                }else{
                    this.setState({preloader:false,qr_code:false});
                    const msg =resp && resp.data.message?resp.data.message:'Please enter required feilds...';                     
                    toast.error(msg);
                }
            });
            Http.cancel(requestId);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }
    qrcode(Qrcode){
        this.submitForm(Qrcode);
    }
    enableQR=()=>{
        this.setState({qr_code:!this.state.qr_code });
    }
    render() { 
        const {preloader, qr_code}=this.state;
        const usernameValid= this.validator.message('username', this.state.username, 'required');
        const passwordValid= this.validator.message('password', this.state.password, 'required');
      

        return  <div>
            <div className="grid-container">
                <div>
                    <img src={`${window.publicUrl}/assets/img/avatars/logo.png`} style={{
                        width:'115px',
                        height:'130px',
                        marginLeft: '10px'
                    }} />
                </div>
                <div className="header_text title-Text">
                    <div >
                        College Management Software
                    </div>
                    <div >
                        College of Agricultural Technology - Theni
                    </div>
                </div>
                <div>
                    <img style={{
                        width:'156px',
                        height:'135px',
                        paddingRight: '10px',
                        float:'right'
                    }} src={`${window.publicUrl}/assets/img/avatars/footer-logo.png`}/>
                </div>   
            </div>
            <div className="login-containter">
                <div></div>
                <div id="item1" style={{justifySelf:'right',width:'95%'}}>
                    <div className="login_heading">
                        <div className="user_avatar" style={{textAlign:'center'}}>
                            <img style={{width:'80px',height:'80px'}} src={`${window.publicUrl}/assets/img/avatars/common_avatar.png`}/>
                        </div>
                    </div>
                    <div className="md-card-content large-padding" id="login_form">  
                        <div className="uk-form-row">
                            <label style={{color:'#ffffff'}} htmlFor="username">Username</label>
                            <input style={{color:'#ffffff',borderColor:'#ffffff'}} type="text" name="username" value={this.state.username} onChange={this.setStateFromInput} className={ `md-input ${usernameValid ?'md-input-danger':''}`}  onKeyPress={(e)=>{
                                if(e.charCode===13){ 
                                    this.submitForm(); 
                                } 
                            }} />
                            {usernameValid} 
                        </div>
                        <div className="uk-form-row">
                            <label style={{color:'#ffffff'}} htmlFor="login_password">Password</label> 
                            <input style={{color:'#ffffff',borderColor:'#ffffff'}} type="password" name="password" value={this.state.password} onChange={this.setStateFromInput} className={ `md-input ${passwordValid ?'md-input-danger':''}`} onKeyPress={(e)=>{
                                if(e.charCode===13){ 
                                    this.submitForm(); 
                                } 
                            }} />
                            {passwordValid} 
                        </div>
                        <div className="uk-margin-medium-top" style={{textAlign:'center'}}>
                            <button type="button" style={{background:'#5AAAC4'}} onClick={()=>this.submitForm()} className="md-btn md-btn-primary">Sign In</button>
                        </div> 
                    </div>
                </div>
                <div id="item2">
                    <div style={{    height: '86%',width:'178px'}}>
                        { qr_code ? <Qrcode qrcode={(e)=>this.qrcode(e)}/>:<i style={{fontSize:'80px',color:'rgb(255, 255, 255)',marginLeft:'22%',marginTop:'40%'}} className="md-icon material-icons">camera_alt</i>}
                    </div>
                   
                    <div>
                        <button type="button" style={{background:'#5AAAC4'}}  onClick={this.enableQR} className="md-btn md-btn-primary">{ qr_code?'Close QR-Scanner':'QR-Code Sign In'}</button>
                    </div>
                </div>
                <div id="item3" style={{justifySelf:'left',padding:'0px'}} className="md-card">
                    <div  style={{cursor:'pointer'}} onClick={()=>this.submitForm('guest')}>
                        <div className="uk-text-center">
                            <img style={{width:'80px',height:'80px',marginTop:'0px'}} className="md-card-head-avatar" src={`${window.publicUrl}/assets/img/avatars/user@2x.png`} />
                        </div> 
                        <h3 className="md-card-head-text uk-text-center">
                                Guest User 
                        </h3>
                    </div>
                </div>
            
                { preloader && <Preloader/> }
            </div> 
        </div> 
        ;
    }
}
 
export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/components/Login/Login.js